import React, { useState } from "react";
import ProfileCard from "../../../components/cards/ProfileCard";
import SecurityCard from "../../../components/cards/SecurityCard";
import EditProfileModal from "./EditProfileModal";
import ChangePasswordModal from "./ChangePassword";
import SuccessModal from "../../../components/cards/SuccesCard";
import ResetPassword from "./ResetPasswordModals";
import SetTwoFactorAuth from "./SetTwoFactorAuth";
import { useAppSelector } from "../../../redux/app/hooks";
import ConfigurationSettings from "./ConfigurationSettings";

const ProfileAndSecurity: React.FC = () => {
  const { adminProfile } = useAppSelector((state) => state.admin);
  const [openEditProfile, setOpenEditProfile] = useState(false);
  const [editProfileSuccess, setEditProfileSuccess] = useState(false);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const [changePasswordSuccess, setChangePasswordSuccess] = useState(false);
  const [openResetPassword, setOpenResetPassword] = useState(false);
  const [openEnableTwoFactor, setOpenEnableTwoFactor] = useState(false);
  const [openEnableTwoFactorSuccess, setOpenEnableTwoFactorSuccess] =
    useState(false);

  const profileDetails = [
    { label: "First Name", value: adminProfile?.firstName },
    { label: "Last Name", value: adminProfile?.lastName },
    { label: "Email address", value: adminProfile?.email },
    { label: "Phone number", value: adminProfile?.phoneNumber },
    {
      label: "User Role",
      value: adminProfile?.roles === "INVESTOR" ? "User" : adminProfile?.roles,
    },
  ];

  const handleEditProfile = () => {
    setOpenEditProfile(true);
  };

  return (
    <div className=" bg-gray-100 min-h-screen">
      <div className=" mx-auto grid md:grid-cols-2 gap-6 mb-6">
        {/* Profile Details */}
        <ProfileCard
          title="Profile details"
          data={profileDetails}
          buttonLabel="Edit profile"
          onButtonClick={handleEditProfile}
        />

        {/* Security Settings */}
        <div className="bg-white  rounded-3xl ">
          <h2 className="text-lg font-semibold mb-4 border-b border-borderColor py-6 px-6">
            Security
          </h2>
          <div className="space-y-4 p-6">
            <SecurityCard
              title="Two-factor Authentication"
              description="Use an authentication app to protect your account."
              buttonLabel="Activate"
              onButtonClick={() => setOpenEnableTwoFactor(true)}
            />
            <SecurityCard
              title="Change password"
              description="Choose a strong, unique password that only you can know."
              buttonLabel="Change"
              onButtonClick={() => setOpenChangePassword(true)}
            />
            {/* <SecurityCard
              title="Reset password"
              description="Reset your password in a few simple steps."
              buttonLabel="Reset"
              onButtonClick={() => setOpenResetPassword(true)}
            /> */}
          </div>
        </div>
      </div>

      {/* Configuration Settings */}
      {adminProfile?.roles === "SUPER_ADMIN" && <ConfigurationSettings />}

      {/* Modals */}
      <EditProfileModal
        open={openEditProfile}
        onClose={() => setOpenEditProfile(false)}
        onSuccess={() => {
          setEditProfileSuccess(true);
          setOpenEditProfile(false);
        }}
      />
      <SuccessModal
        isOpen={editProfileSuccess}
        onClose={() => setEditProfileSuccess(false)}
        title="Profile Updated"
        description="Your profile has been updated successfully"
        onConfirm={() => setEditProfileSuccess(false)}
        confirmText="Confirm"
      />
      <ChangePasswordModal
        open={openChangePassword}
        onClose={() => setOpenChangePassword(false)}
        onSuccess={() => {
          setChangePasswordSuccess(true);
          setOpenChangePassword(false);
        }}
      />
      <SuccessModal
        isOpen={changePasswordSuccess}
        onClose={() => setChangePasswordSuccess(false)}
        title="Password changed"
        description="Your password has been changed successfully"
        onConfirm={() => setChangePasswordSuccess(false)}
        confirmText="Confirm"
      />
      {openResetPassword && (
        <ResetPassword onClose={() => setOpenResetPassword(false)} />
      )}
      <SetTwoFactorAuth
        open={openEnableTwoFactor}
        onClose={() => setOpenEnableTwoFactor(false)}
        onSuccess={() => {
          setOpenEnableTwoFactorSuccess(true);
          setOpenEnableTwoFactor(false);
        }}
      />
      <SuccessModal
        isOpen={openEnableTwoFactorSuccess}
        onClose={() => setOpenEnableTwoFactorSuccess(false)}
        title="Two-factor authentication enabled"
        description="Your authenticator app will be used to verify your account on subsequent login."
        onConfirm={() => setOpenEnableTwoFactorSuccess(false)}
        confirmText="Confirm"
      />
    </div>
  );
};

export default ProfileAndSecurity;
